import { toDate, toDateUtc } from "@gsx/common";

export const adaptDate = (value: any): Date | undefined => toDate(value) || undefined;
export const adaptDateUtc = (value: any): Date | undefined => toDateUtc(value) || undefined;
